import React, { memo } from "react";
import LoginLayout from "@layout/LoginLayout";
import { hs } from "@hlibs/index";
import CompLogin from "@components/CompLogin";

const ViewLogin = memo(() => {
  return (
    <LoginLayout style={[hs.backgroundColor("#FAFAFB")]}>
      <CompLogin />
    </LoginLayout>
  );
}, []);

export default ViewLogin;
